import { render, staticRenderFns } from "./client.vue?vue&type=template&id=27655462&scoped=true&"
import script from "./client.vue?vue&type=script&lang=js&"
export * from "./client.vue?vue&type=script&lang=js&"
import style0 from "./client.vue?vue&type=style&index=0&id=27655462&prod&lang=css&"
import style1 from "./client.vue?vue&type=style&index=1&id=27655462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27655462",
  null
  
)

export default component.exports